import React from 'react';
import { ViewerTemplate } from '../ViewerTemplate';
import { GrayCard } from '../shared/GrayCard';
import { Header5Text } from 'ui-toolkit/components';
import { IFlatEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IFlatEndorsementConfig';
import { ILoanCalcEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/ILoanCalcEndorsementConfig';
import { IPolicyCalcEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IPolicyCalcEndorsementConfig';
import { pluralize, isPluralArray } from 'utilities/shared/stringMethods/pluralize';

export enum eEndorsementNames {
  Flat = 'Flat Endorsement',
  LoanCalc = 'Loan Calculation Endorsement',
  PolicyCalc = 'Policy Calculation Endorsement',
}

interface ITemplateEndorsementsViewerProps {
  endorsementName: eEndorsementNames;
  endorsements: (IFlatEndorsementConfigData | ILoanCalcEndorsementConfigData | IPolicyCalcEndorsementConfigData)[];
  children: React.ReactNode;
}

const endorsementSectionTitle = (
  endorsementName: eEndorsementNames,
  endorsements: (IFlatEndorsementConfigData | ILoanCalcEndorsementConfigData | IPolicyCalcEndorsementConfigData)[]
): string =>
  `There ${pluralize(isPluralArray(endorsements), 'is', 'are')} ${endorsements.length} ${endorsementName}${pluralize(
    isPluralArray(endorsements)
  )}`;

export const TemplateEndorsementsViewer: React.FC<ITemplateEndorsementsViewerProps> = ({
  endorsementName,
  endorsements,
  children,
}) => (
  <ViewerTemplate viewerName={endorsementName + 's'}>
    <GrayCard title={<Header5Text>{endorsementSectionTitle(endorsementName, endorsements)}</Header5Text>}>
      {children}
    </GrayCard>
  </ViewerTemplate>
);
